const trustPoints = [
  {
    icon: 'ri-award-line',
    title: '18 Yıllık Tecrübe',
    description: '2006\'dan bu yana binlerce müşteriye profesyonel temizlik hizmeti sunduk.',
    color: 'bg-amber-50 text-amber-600',
  },
  {
    icon: 'ri-tools-line',
    title: 'Profesyonel Ekipman',
    description: 'Endüstriyel sınıf makineler ve son teknoloji ekipmanlarla mükemmel sonuç garantisi.',
    color: 'bg-sky-50 text-sky-600',
  },
  {
    icon: 'ri-flask-line',
    title: 'Özel Kimyasallar',
    description: 'Çocuklara ve evcil hayvanlara zararsız, sertifikalı profesyonel temizlik ürünleri.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Kurumsal Kapasite',
    description: 'Otel, site ve büyük projelerde toplu hizmet verebilme altyapısı ve ekibi.',
    color: 'bg-violet-50 text-violet-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sigortalı Hizmet',
    description: 'Güvenli ve sigortalı çalışma anlayışı ile evinizde ve iş yerinizde sorunsuz hizmet.',
    color: 'bg-rose-50 text-rose-600',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Geniş Hizmet Alanı',
    description: 'İstanbul\'un her iki yakası, Kocaeli ve Yalova\'da ekiplerimiz hizmetinizde.',
    color: 'bg-sky-50 text-sky-600',
  },
];

export default function TrustSection() {
  return (
    <section id="neden-biz" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-100 text-sky-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Neden Biz?
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">
            Evrensel Temizlik Farkı
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            18 yıllık birikimimiz ve profesyonel yaklaşımımızla sektörde fark yaratıyoruz.
          </p>
        </div>

        {/* Stats Banner */}
        <div className="bg-sky-600 rounded-2xl p-8 md:p-10 mb-14 grid grid-cols-2 md:grid-cols-4 gap-6 text-white text-center">
          {[
            { value: '18+', label: 'Yıl Tecrübe' },
            { value: '5.000+', label: 'Mutlu Müşteri' },
            { value: '200+', label: 'Kurumsal Müşteri' },
            { value: '7/24', label: 'Destek Hattı' },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-4xl md:text-5xl font-bold mb-1">{stat.value}</div>
              <div className="text-sky-200 text-sm font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {trustPoints.map((item) => (
            <div
              key={item.title}
              className="group flex gap-4 items-start bg-slate-50 hover:bg-white border border-slate-100 hover:border-sky-100 p-6 rounded-2xl transition-all duration-300 hover:shadow-md"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-2xl`} />
              </div>
              <div>
                <h3 className="text-base font-bold text-slate-900 mb-1">{item.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* How It Works */}
        <div className="mt-20">
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">Nasıl Çalışıyoruz?</h3>
            <p className="text-slate-500">3 basit adımda temiz evinize kavuşun</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
            {/* Connector Line */}
            <div className="hidden md:block absolute top-10 left-1/4 right-1/4 h-0.5 bg-sky-200 z-0" />

            {[
              { step: '01', icon: 'ri-list-check-2', title: 'Hizmeti Seçin', desc: 'İhtiyacınıza uygun temizlik hizmetini seçin veya bizimle iletişime geçin.' },
              { step: '02', icon: 'ri-phone-line', title: 'Bize Ulaşın', desc: 'Telefon, WhatsApp veya randevu formu üzerinden bizimle iletişime geçin.' },
              { step: '03', icon: 'ri-group-2-line', title: 'Ekibimiz Gelsin', desc: 'Profesyonel ekibimiz belirlenen tarihte kapınızda olsun.' },
            ].map((item, i) => (
              <div key={item.step} className="relative z-10 text-center bg-white border border-slate-100 rounded-2xl p-8 shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center bg-sky-600 text-white rounded-2xl mx-auto mb-4 text-2xl font-bold">
                  {item.step}
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-sky-50 rounded-xl mx-auto mb-3">
                  <i className={`${item.icon} text-sky-600 text-xl`} />
                </div>
                <h4 className="text-lg font-bold text-slate-900 mb-2">{item.title}</h4>
                <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
